/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_1_LinkInputs */

const en_mk_sec_1_link = /** @type {(inputs: Mk_Sec_1_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How sync works`)
};

const id_mk_sec_1_link = /** @type {(inputs: Mk_Sec_1_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cara kerja sync`)
};

/**
* | output |
* | --- |
* | "How sync works" |
*
* @param {Mk_Sec_1_LinkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_1_link = /** @type {((inputs?: Mk_Sec_1_LinkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_1_LinkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_1_link(inputs)
	return en_mk_sec_1_link(inputs)
});